
function SeedInputMaterialController($scope, TranslationService, MaterialService, $timeout, $element) {
    var ctrl = this;

    //ctrl.errorMsg = 'Material inválido';

    ctrl.translation = TranslationService.getActiveTranslation();
    ctrl.copy = function (text) {
        if (window.clipboardData && window.clipboardData.setData) {
            return clipboardData.setData("Text", text);
        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");  // Security exception may be thrown by some browsers.
            } catch (ex) {
                console.warn("Copy to clipboard failed.", ex);
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        }
    };

    ctrl.selectItem = function (item) {
        console.log('ctrl.selectItem ' + item.Key);
        //console.log(item);

        ctrl.notFound = false;
        ctrl.modelItem.MaterialID = item.Key;

        ctrl.modelItem.MaterialSKU = item.MaterialSKU;
        ctrl.modelItem.RefCode = item.RefCode;
        ctrl.modelItem.DrawingID = item.DrawingID;

        //ctrl.modelItem.c_QtStocks = item.c_QtStocks;
        //ctrl.modelItem.c_QtStocksFinal = item.c_QtStocksFinal;
        //ctrl.modelItem.c_QtM0POs = item.c_QtM0POs;
        //ctrl.modelItem.c_QtM1POs = item.c_QtM1POs;
        //ctrl.modelItem.c_QtM2POs = item.c_QtM2POs;
        //ctrl.modelItem.c_QtM3POs = item.c_QtM3POs;
        //ctrl.modelItem.Horsepower = item.Horsepower;
        //ctrl.modelItem.ProductType = item.ProductType;
        //ctrl.modelItem.Prices = item.Prices;
        //ctrl.modelItem.AltMaterialID01 = item.AltMaterialID01;
        //ctrl.modelItem.AltMaterialID02 = item.AltMaterialID02;
        //ctrl.modelItem.AltMaterialID03 = item.AltMaterialID03;
        //$scope.user.ContactName = item.Value;

        //FOCUS NO INPUT
        ctrl.onSelectItem(ctrl.modelItem);

        /* JRM: NAO FUNCIONA, PERDE FOCO DO INPUT QUANDO STORAGEID E PREENCHIDO
        $timeout(function () {
            console.log('FOCA INPUT');
            //document.getElementById('id-input-mat').focus();
            //document.getElementsByTagName('input').focus();
            $element.find('input').focus();
        }, 5000, false);
        */
    };

    ctrl.subsCount = function (matchModel) {
        console.log('subsCount');
        var count = 0;
        if (matchModel.AltMaterialID01) {
            count++;
        }
        if (matchModel.AltMaterialID02) {
            count++;
        }
        if (matchModel.AltMaterialID03) {
            count++;
        }
        return count;
    };

    ctrl.openMaterialModal = function (materialID) {
        //JRM: DESABILIDADO TEMPORARIAMENTE
        //MaterialService.openMaterialModal(materialID);
    };

    
    ctrl.isTableData = function (clipText) {
        //Remove ultimo CRLF
        //if (clipText.length > 0) {
        //    if (clipText[clipText.length - 1] == String.fromCharCode(13)) {
        //        console.log('LASTCHAR=13');
        //    }
        //    if (clipText[clipText.length - 1] == String.fromCharCode(10)) {
        //        console.log('LASTCHAR=10');
        //    }
        //}
        //Remove brancos, crlf do inicio e fim
        clipText = $.trim(clipText);
        if (clipText.includes(String.fromCharCode(13))){
            return true;
        }
        if (clipText.includes(String.fromCharCode(9))){
            return true;
        }
        return false;
    }

    ctrl.pasteText = function (ev) {
        //console.log('pasteTEXT');
        var clipText = ev.originalEvent.clipboardData.getData('Text');
        console.log('pasteText: ' + clipText);
        //Verifica se texto complexo (CH13, CH10, CH9)
        if (clipText && ctrl.isTableData(clipText)) {
            ev.stopPropagation();
            ev.preventDefault();
            ctrl.onPasteTable(clipText);
            return;
        }                       
        
    };

    ctrl.onExitControl = function () {
        console.log('EXIT CONTROL model-name: ' + ctrl.model + ' model-id: ' + ctrl.modelId);
        //console.log(ctrl.modelItem);

        //if (ctrl.loadingSearch) {
        //    ctrl.exitWhileSearching = true;
        //}
        ctrl.wasAbandoned = true;

        if (ctrl.modelNull && !ctrl.model) {
            ctrl.selectItem({ item: ctrl.modelItem });
            //ctrl.selectItem({});
        }
    };

    ctrl.findMaterialExact = function (query, results) {
        if (results.length == 1) {
            if (results[0].Key == query) {
                return results[0];
            }
            return null;
        }
        for (var i = 0; i < results.length; i++) {
            if (results[i].Key == query) {
                return results[i];
            }
        }
        return null;
    };

    ctrl.materialSearch = function (query) {
        ctrl.loadingSearch = true;
        ctrl.notFound = false;
        console.log('materialSearch');
        return MaterialService.getMaterialsQuery(query)
            .then(function (response) {
                console.log('materialSearch RETURN');
                var data = response.data;
                var exact = ctrl.findMaterialExact(query, data);
                ctrl.notFound = exact == null;
                if (ctrl.wasAbandoned) {
                    console.log('wasAbandoned = ' + query);
                    if (exact) {
                        ctrl.selectItem(exact);
                    }
                }
                /*
                if (data.length == 1) {
                    ctrl.oneFound = true;
                    ctrl.oneKey = data[0].Key;
                    if (ctrl.wasAbandoned && ctrl.oneKey == query) {
                        console.log('wasAbandoned = ' + ctrl.oneKey);
                        ctrl.selectItem(data[0]);
                    }
                }
                */
                ctrl.loadingSearch = false;
                return response.data.map(function (item) {
                    return item;
                });
            })
            .catch(function (err) {
                ctrl.loadingSearch = false;
                console.error(err);
            });
    };

    //ctrl.materialFocus = function (index) {
    //    console.log('SD-INPUT-MATERIAL > materialFocus ' + index);
    //};

    //ctrl.materialClicked = function (index) {
    //    console.log('SD-INPUT-MATERIAL > materialClicked ' + index);
    //};
}

SeedInputMaterialController.$inject = ['$scope', 'TranslationService', 'MaterialService', '$timeout', '$element'];

seedWebApp.component('sdInputMaterial', {
    controller: SeedInputMaterialController,
    bindings: {
        inputType: '<',         // Tipos (text, date, switch, select, btn-group, link, debounce, typeahead, checkbox, number, textarea, flag)
        options: '<',           // Modelo (Key, Value)
        label: '<',             // Label do input
        model: '=',             // Modelo à ser alterado
        modelId: '=',           // ID do modelo
        modelItem: '=',         // Item do modelo
        disabled: '<',          // Define se campo está desabilitado para edição
        typeaheadService: '<',  // Serviço que trás valores para Typeahead
        onSelectItem: '<',      // Função que é ativada ao selecionar valor no Typeahead ou select
        onPasteTable: '<',      // PasteTable
        debounce: '=',          // Função ativada no debounce do input
        required: '=',          // Define se o input é necessário ou não, o circulando de vermelho caso esteja vazio
        modelNull: '<',         // Define se o modelo deve ser atualizado para nulo quando a caixa de input fica vazia
    },
    templateUrl: '/SPA/Components/sd-input-material.html'
});